module.exports = __webpack_public_path__ + "media/4s.386ec929.mp3";